import { jsx, Fragment } from "react/jsx-runtime";
import require$$0, { useMemo, useEffect, useCallback } from "react";
import { useApplication } from "@bonusly/application";
import { createInstance, Types, Identify } from "@amplitude/marketing-analytics-browser";
import { subSeconds, isAfter } from "date-fns";
import decode from "jwt-decode";
import { Experiment } from "@amplitude/experiment-js-client";
import Cookies from "js-cookie";
import { HttpError } from "@bonusly/http";
function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function(resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function shallow$1(objA, objB) {
  if (Object.is(objA, objB)) {
    return true;
  }
  if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) {
    return false;
  }
  if (objA instanceof Map && objB instanceof Map) {
    if (objA.size !== objB.size)
      return false;
    for (const [key, value] of objA) {
      if (!Object.is(value, objB.get(key))) {
        return false;
      }
    }
    return true;
  }
  if (objA instanceof Set && objB instanceof Set) {
    if (objA.size !== objB.size)
      return false;
    for (const value of objA) {
      if (!objB.has(value)) {
        return false;
      }
    }
    return true;
  }
  const keysA = Object.keys(objA);
  if (keysA.length !== Object.keys(objB).length) {
    return false;
  }
  for (const keyA of keysA) {
    if (!Object.prototype.hasOwnProperty.call(objB, keyA) || !Object.is(objA[keyA], objB[keyA])) {
      return false;
    }
  }
  return true;
}
function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
var withSelector = { exports: {} };
var withSelector_production_min = {};
var shim = { exports: {} };
var useSyncExternalStoreShim_production_min = {};
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredUseSyncExternalStoreShim_production_min;
function requireUseSyncExternalStoreShim_production_min() {
  if (hasRequiredUseSyncExternalStoreShim_production_min)
    return useSyncExternalStoreShim_production_min;
  hasRequiredUseSyncExternalStoreShim_production_min = 1;
  var e = require$$0;
  function h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
  }
  var k = "function" === typeof Object.is ? Object.is : h, l = e.useState, m = e.useEffect, n = e.useLayoutEffect, p = e.useDebugValue;
  function q(a, b) {
    var d = b(), f = l({ inst: { value: d, getSnapshot: b } }), c = f[0].inst, g = f[1];
    n(function() {
      c.value = d;
      c.getSnapshot = b;
      r(c) && g({ inst: c });
    }, [a, d, b]);
    m(function() {
      r(c) && g({ inst: c });
      return a(function() {
        r(c) && g({ inst: c });
      });
    }, [a]);
    p(d);
    return d;
  }
  function r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
      var d = b();
      return !k(a, d);
    } catch (f) {
      return true;
    }
  }
  function t(a, b) {
    return b();
  }
  var u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? t : q;
  useSyncExternalStoreShim_production_min.useSyncExternalStore = void 0 !== e.useSyncExternalStore ? e.useSyncExternalStore : u;
  return useSyncExternalStoreShim_production_min;
}
var useSyncExternalStoreShim_development = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredUseSyncExternalStoreShim_development;
function requireUseSyncExternalStoreShim_development() {
  if (hasRequiredUseSyncExternalStoreShim_development)
    return useSyncExternalStoreShim_development;
  hasRequiredUseSyncExternalStoreShim_development = 1;
  if (process.env.NODE_ENV !== "production") {
    (function() {
      if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart === "function") {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
      }
      var React = require$$0;
      var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      function error(format) {
        {
          {
            for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
              args[_key2 - 1] = arguments[_key2];
            }
            printWarning("error", format, args);
          }
        }
      }
      function printWarning(level, format, args) {
        {
          var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
          var stack = ReactDebugCurrentFrame.getStackAddendum();
          if (stack !== "") {
            format += "%s";
            args = args.concat([stack]);
          }
          var argsWithFormat = args.map(function(item) {
            return String(item);
          });
          argsWithFormat.unshift("Warning: " + format);
          Function.prototype.apply.call(console[level], console, argsWithFormat);
        }
      }
      function is(x, y) {
        return x === y && (x !== 0 || 1 / x === 1 / y) || x !== x && y !== y;
      }
      var objectIs = typeof Object.is === "function" ? Object.is : is;
      var useState = React.useState, useEffect2 = React.useEffect, useLayoutEffect = React.useLayoutEffect, useDebugValue2 = React.useDebugValue;
      var didWarnOld18Alpha = false;
      var didWarnUncachedGetSnapshot = false;
      function useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
        {
          if (!didWarnOld18Alpha) {
            if (React.startTransition !== void 0) {
              didWarnOld18Alpha = true;
              error("You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release.");
            }
          }
        }
        var value = getSnapshot();
        {
          if (!didWarnUncachedGetSnapshot) {
            var cachedValue = getSnapshot();
            if (!objectIs(value, cachedValue)) {
              error("The result of getSnapshot should be cached to avoid an infinite loop");
              didWarnUncachedGetSnapshot = true;
            }
          }
        }
        var _useState = useState({
          inst: {
            value,
            getSnapshot
          }
        }), inst = _useState[0].inst, forceUpdate = _useState[1];
        useLayoutEffect(function() {
          inst.value = value;
          inst.getSnapshot = getSnapshot;
          if (checkIfSnapshotChanged(inst)) {
            forceUpdate({
              inst
            });
          }
        }, [subscribe, value, getSnapshot]);
        useEffect2(function() {
          if (checkIfSnapshotChanged(inst)) {
            forceUpdate({
              inst
            });
          }
          var handleStoreChange = function() {
            if (checkIfSnapshotChanged(inst)) {
              forceUpdate({
                inst
              });
            }
          };
          return subscribe(handleStoreChange);
        }, [subscribe]);
        useDebugValue2(value);
        return value;
      }
      function checkIfSnapshotChanged(inst) {
        var latestGetSnapshot = inst.getSnapshot;
        var prevValue = inst.value;
        try {
          var nextValue = latestGetSnapshot();
          return !objectIs(prevValue, nextValue);
        } catch (error2) {
          return true;
        }
      }
      function useSyncExternalStore$1(subscribe, getSnapshot, getServerSnapshot) {
        return getSnapshot();
      }
      var canUseDOM = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
      var isServerEnvironment = !canUseDOM;
      var shim2 = isServerEnvironment ? useSyncExternalStore$1 : useSyncExternalStore;
      var useSyncExternalStore$2 = React.useSyncExternalStore !== void 0 ? React.useSyncExternalStore : shim2;
      useSyncExternalStoreShim_development.useSyncExternalStore = useSyncExternalStore$2;
      if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop === "function") {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
      }
    })();
  }
  return useSyncExternalStoreShim_development;
}
var hasRequiredShim;
function requireShim() {
  if (hasRequiredShim)
    return shim.exports;
  hasRequiredShim = 1;
  if (process.env.NODE_ENV === "production") {
    shim.exports = requireUseSyncExternalStoreShim_production_min();
  } else {
    shim.exports = requireUseSyncExternalStoreShim_development();
  }
  return shim.exports;
}
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredWithSelector_production_min;
function requireWithSelector_production_min() {
  if (hasRequiredWithSelector_production_min)
    return withSelector_production_min;
  hasRequiredWithSelector_production_min = 1;
  var h = require$$0, n = requireShim();
  function p(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
  }
  var q = "function" === typeof Object.is ? Object.is : p, r = n.useSyncExternalStore, t = h.useRef, u = h.useEffect, v = h.useMemo, w = h.useDebugValue;
  withSelector_production_min.useSyncExternalStoreWithSelector = function(a, b, e, l, g) {
    var c = t(null);
    if (null === c.current) {
      var f = { hasValue: false, value: null };
      c.current = f;
    } else
      f = c.current;
    c = v(function() {
      function a2(a3) {
        if (!c2) {
          c2 = true;
          d2 = a3;
          a3 = l(a3);
          if (void 0 !== g && f.hasValue) {
            var b2 = f.value;
            if (g(b2, a3))
              return k = b2;
          }
          return k = a3;
        }
        b2 = k;
        if (q(d2, a3))
          return b2;
        var e2 = l(a3);
        if (void 0 !== g && g(b2, e2))
          return b2;
        d2 = a3;
        return k = e2;
      }
      var c2 = false, d2, k, m = void 0 === e ? null : e;
      return [function() {
        return a2(b());
      }, null === m ? void 0 : function() {
        return a2(m());
      }];
    }, [b, e, l, g]);
    var d = r(a, c[0], c[1]);
    u(function() {
      f.hasValue = true;
      f.value = d;
    }, [d]);
    w(d);
    return d;
  };
  return withSelector_production_min;
}
var withSelector_development = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredWithSelector_development;
function requireWithSelector_development() {
  if (hasRequiredWithSelector_development)
    return withSelector_development;
  hasRequiredWithSelector_development = 1;
  if (process.env.NODE_ENV !== "production") {
    (function() {
      if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart === "function") {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
      }
      var React = require$$0;
      var shim2 = requireShim();
      function is(x, y) {
        return x === y && (x !== 0 || 1 / x === 1 / y) || x !== x && y !== y;
      }
      var objectIs = typeof Object.is === "function" ? Object.is : is;
      var useSyncExternalStore = shim2.useSyncExternalStore;
      var useRef = React.useRef, useEffect2 = React.useEffect, useMemo2 = React.useMemo, useDebugValue2 = React.useDebugValue;
      function useSyncExternalStoreWithSelector2(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
        var instRef = useRef(null);
        var inst;
        if (instRef.current === null) {
          inst = {
            hasValue: false,
            value: null
          };
          instRef.current = inst;
        } else {
          inst = instRef.current;
        }
        var _useMemo = useMemo2(function() {
          var hasMemo = false;
          var memoizedSnapshot;
          var memoizedSelection;
          var memoizedSelector = function(nextSnapshot) {
            if (!hasMemo) {
              hasMemo = true;
              memoizedSnapshot = nextSnapshot;
              var _nextSelection = selector(nextSnapshot);
              if (isEqual !== void 0) {
                if (inst.hasValue) {
                  var currentSelection = inst.value;
                  if (isEqual(currentSelection, _nextSelection)) {
                    memoizedSelection = currentSelection;
                    return currentSelection;
                  }
                }
              }
              memoizedSelection = _nextSelection;
              return _nextSelection;
            }
            var prevSnapshot = memoizedSnapshot;
            var prevSelection = memoizedSelection;
            if (objectIs(prevSnapshot, nextSnapshot)) {
              return prevSelection;
            }
            var nextSelection = selector(nextSnapshot);
            if (isEqual !== void 0 && isEqual(prevSelection, nextSelection)) {
              return prevSelection;
            }
            memoizedSnapshot = nextSnapshot;
            memoizedSelection = nextSelection;
            return nextSelection;
          };
          var maybeGetServerSnapshot = getServerSnapshot === void 0 ? null : getServerSnapshot;
          var getSnapshotWithSelector = function() {
            return memoizedSelector(getSnapshot());
          };
          var getServerSnapshotWithSelector = maybeGetServerSnapshot === null ? void 0 : function() {
            return memoizedSelector(maybeGetServerSnapshot());
          };
          return [getSnapshotWithSelector, getServerSnapshotWithSelector];
        }, [getSnapshot, getServerSnapshot, selector, isEqual]), getSelection = _useMemo[0], getServerSelection = _useMemo[1];
        var value = useSyncExternalStore(subscribe, getSelection, getServerSelection);
        useEffect2(function() {
          inst.hasValue = true;
          inst.value = value;
        }, [value]);
        useDebugValue2(value);
        return value;
      }
      withSelector_development.useSyncExternalStoreWithSelector = useSyncExternalStoreWithSelector2;
      if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop === "function") {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
      }
    })();
  }
  return withSelector_development;
}
if (process.env.NODE_ENV === "production") {
  withSelector.exports = requireWithSelector_production_min();
} else {
  withSelector.exports = requireWithSelector_development();
}
var withSelectorExports = withSelector.exports;
const useSyncExternalStoreExports = /* @__PURE__ */ getDefaultExportFromCjs(withSelectorExports);
const createStoreImpl = (createState) => {
  let state;
  const listeners = /* @__PURE__ */ new Set();
  const setState = (partial, replace) => {
    const nextState = typeof partial === "function" ? partial(state) : partial;
    if (!Object.is(nextState, state)) {
      const previousState = state;
      state = (replace != null ? replace : typeof nextState !== "object" || nextState === null) ? nextState : Object.assign({}, state, nextState);
      listeners.forEach((listener) => listener(state, previousState));
    }
  };
  const getState = () => state;
  const getInitialState = () => initialState;
  const subscribe = (listener) => {
    listeners.add(listener);
    return () => listeners.delete(listener);
  };
  const destroy = () => {
    if (({ "BASE_URL": "/", "MODE": "production", "DEV": false, "PROD": true, "SSR": false } ? "production" : void 0) !== "production") {
      console.warn(
        "[DEPRECATED] The `destroy` method will be unsupported in a future version. Instead use unsubscribe function returned by subscribe. Everything will be garbage-collected if store is garbage-collected."
      );
    }
    listeners.clear();
  };
  const api = { setState, getState, getInitialState, subscribe, destroy };
  const initialState = state = createState(setState, getState, api);
  return api;
};
const createStore = (createState) => createState ? createStoreImpl(createState) : createStoreImpl;
const { useDebugValue } = require$$0;
const { useSyncExternalStoreWithSelector } = useSyncExternalStoreExports;
const identity = (arg) => arg;
function useStoreWithEqualityFn(api, selector = identity, equalityFn) {
  const slice = useSyncExternalStoreWithSelector(
    api.subscribe,
    api.getState,
    api.getServerState || api.getInitialState,
    selector,
    equalityFn
  );
  useDebugValue(slice);
  return slice;
}
const createWithEqualityFnImpl = (createState, defaultEqualityFn) => {
  const api = createStore(createState);
  const useBoundStoreWithEqualityFn = (selector, equalityFn = defaultEqualityFn) => useStoreWithEqualityFn(api, selector, equalityFn);
  Object.assign(useBoundStoreWithEqualityFn, api);
  return useBoundStoreWithEqualityFn;
};
const createWithEqualityFn = (createState, defaultEqualityFn) => createState ? createWithEqualityFnImpl(createState, defaultEqualityFn) : createWithEqualityFnImpl;
const useIdentityStore = createWithEqualityFn(() => ({
  analyticsAPIKey: "",
  analyticsClient: createInstance(),
  analyticsServerURL: void 0,
  areFeaturesFetched: false,
  areGlobalFeaturesFetched: false,
  company: void 0,
  companyError: void 0,
  experimentAPIKey: "",
  experimentClient: void 0,
  experimentServerURL: void 0,
  featuresError: void 0,
  globalError: void 0,
  isCompanyFetched: false,
  isInitialized: false,
  isLoadingCompany: false,
  isLoadingFeatures: false,
  isLoadingGlobalFeatures: false,
  isLoadingUser: false,
  isUserFetched: false,
  onError: void 0,
  profileBaseURL: "",
  token: void 0,
  user: void 0,
  userError: void 0
}), shallow$1);
const initializeAnalytics = ({ company, user }) => {
  const { analyticsClient: client, analyticsAPIKey, analyticsServerURL } = useIdentityStore.getState();
  if (client.getUserId() || !analyticsAPIKey) {
    return;
  }
  client.init(analyticsAPIKey, user.id, Object.assign({ logLevel: Types.LogLevel.Error, pageViewTracking: {
    trackHistoryChanges: "pathOnly"
  } }, !!analyticsServerURL && {
    serverUrl: analyticsServerURL
  }));
  client.setGroup("companyId", company.id);
  const identity2 = new Identify();
  identity2.set("created_at", user.created_at).set("email", user.email).set("is_admin", user.admin).set("is_manager", user.is_manager).set("translation_setting", user.locale).set("user_mode", user.user_mode);
  for (const prop of ["department", "role"]) {
    const value = user.custom_properties[prop];
    if (value) {
      identity2.set(prop, value);
    }
  }
  client.identify(identity2);
};
const track = (event, data) => {
  const client = useIdentityStore.getState().analyticsClient;
  return client === null || client === void 0 ? void 0 : client.track(event, data);
};
const useAnalytics = () => {
  return { track };
};
const useCurrentCompany = () => {
  return useIdentityStore((state) => state.company);
};
const useCurrentUser = () => {
  return useIdentityStore((state) => state.user);
};
const EXPIRATION_DRIFT = 5;
const V2_COMPANY_KEY = "https://bonus.ly/company_id";
const V2_USER_KEY = "https://bonus.ly/user_id";
const isV2JWT = (payload) => {
  return !!payload && typeof payload === "object" && V2_USER_KEY in payload && V2_COMPANY_KEY in payload;
};
const isV3JWT = (payload) => {
  return !!payload && typeof payload === "object" && "user_id" in payload && "company_id" in payload;
};
const parseToken = (token) => {
  const emptyResult = {
    expiresAt: void 0,
    companyId: void 0,
    userId: void 0
  };
  if (!token) {
    return emptyResult;
  }
  try {
    const decoded = decode(token);
    if (isV2JWT(decoded)) {
      return {
        expiresAt: decoded.exp ? new Date(decoded.exp * 1e3) : void 0,
        companyId: decoded[V2_COMPANY_KEY],
        userId: decoded[V2_USER_KEY]
      };
    }
    if (isV3JWT(decoded)) {
      return {
        expiresAt: decoded.exp ? new Date(decoded.exp * 1e3) : void 0,
        companyId: decoded.company_id,
        userId: decoded.user_id
      };
    }
    return emptyResult;
  } catch (_a) {
    return emptyResult;
  }
};
const isExpired = (token) => {
  const decoded = parseToken(token);
  if (!decoded.expiresAt) {
    return false;
  }
  const expiration = subSeconds(decoded.expiresAt, EXPIRATION_DRIFT);
  const now = /* @__PURE__ */ new Date();
  return isAfter(now, expiration);
};
const useCurrentUserAuth = () => {
  const token = useIdentityStore((state) => state.token);
  const ids = useMemo(() => parseToken(token), [token]);
  return Object.assign({ hasToken: !!token, token }, ids);
};
const getFeatureValueFn = (client) => (flag) => {
  var _a;
  if (!client) {
    return false;
  }
  return ((_a = client.variant(flag)) === null || _a === void 0 ? void 0 : _a.value) === "on";
};
const enabled = (flag) => {
  const client = useIdentityStore.getState().experimentClient;
  return getFeatureValueFn(client)(flag);
};
function useFeatureFlag(flags) {
  const client = useIdentityStore((state) => state.experimentClient);
  const getFeatureValue = getFeatureValueFn(client);
  if (Array.isArray(flags)) {
    return flags.map(getFeatureValue);
  }
  return getFeatureValue(flags);
}
const fetchFeatureFlags = () => __awaiter(void 0, void 0, void 0, function* () {
  const { areFeaturesFetched, experimentClient, isLoadingFeatures, token } = useIdentityStore.getState();
  if (areFeaturesFetched || isLoadingFeatures) {
    return;
  }
  const { userId } = parseToken(token);
  if (!userId) {
    throw new Error("No user data in JWT");
  }
  useIdentityStore.setState({ isLoadingFeatures: true });
  yield experimentClient.fetch({ user_id: userId });
  useIdentityStore.setState({
    areFeaturesFetched: true,
    isLoadingFeatures: false
  });
  return experimentClient;
});
const fetchGlobalFlags = () => __awaiter(void 0, void 0, void 0, function* () {
  const { areGlobalFeaturesFetched, experimentClient, isLoadingGlobalFeatures } = useIdentityStore.getState();
  if (areGlobalFeaturesFetched || isLoadingGlobalFeatures) {
    return;
  }
  useIdentityStore.setState({ isLoadingGlobalFeatures: true });
  yield experimentClient.fetch();
  useIdentityStore.setState({
    areGlobalFeaturesFetched: true,
    isLoadingGlobalFeatures: false
  });
});
const CSRF_COOKIE_ID = "X-CSRF-TOKEN";
const cleanPath = (path) => {
  return path.match(/\/$/) ? path : path + "/";
};
const normalizePath = (path) => `${path}`.replace(/^\/+|\/+$/g, "");
const joinPath = (...paths) => paths.map(normalizePath).join("/");
const createFetcher = (path) => () => __awaiter(void 0, void 0, void 0, function* () {
  const csrfToken = Cookies.get(CSRF_COOKIE_ID);
  const { profileBaseURL, token } = useIdentityStore.getState();
  const url = new URL(path, cleanPath(profileBaseURL || ""));
  url.searchParams.append("view", "profile");
  const response = yield fetch(url.toString(), {
    headers: new Headers(Object.assign(Object.assign({ Authorization: `Bearer ${token}`.trim() }, csrfToken && {
      [CSRF_COOKIE_ID]: csrfToken
    }), { "X-BONUSLY-SOURCE": "internal" }))
  });
  const data = yield response.json();
  if (!response.ok) {
    throw new HttpError(response.status, data.redirect_url);
  }
  return data.result;
});
const fetchProfiles = () => __awaiter(void 0, void 0, void 0, function* () {
  const { onError, profileBaseURL } = useIdentityStore.getState();
  try {
    if (!profileBaseURL) {
      throw new Error("No `profileBaseURL` configuration provided to identify()");
    }
    const fetchUserProfile = () => __awaiter(void 0, void 0, void 0, function* () {
      try {
        const { isLoadingUser, user: existing } = useIdentityStore.getState();
        if (existing) {
          return existing;
        }
        if (isLoadingUser) {
          return new Promise((resolve) => {
            const unsubscribe = useIdentityStore.subscribe((state) => {
              if (state.isUserFetched || state.userError && !state.isLoadingUser) {
                unsubscribe();
                return resolve(state.user);
              }
            });
          });
        }
        useIdentityStore.setState({ isLoadingUser: true });
        const user2 = yield createFetcher("user")();
        useIdentityStore.setState({
          isLoadingUser: false,
          isUserFetched: true,
          user: user2
        });
        return user2;
      } catch (error) {
        onError === null || onError === void 0 ? void 0 : onError(error);
        useIdentityStore.setState({ isLoadingUser: false, userError: error });
      }
    });
    const fetchCompanyProfile = () => __awaiter(void 0, void 0, void 0, function* () {
      try {
        const { company: existing, isLoadingCompany } = useIdentityStore.getState();
        if (existing) {
          return existing;
        }
        if (isLoadingCompany) {
          return new Promise((resolve) => {
            const unsubscribe = useIdentityStore.subscribe((state) => {
              if (state.isCompanyFetched || state.companyError && !state.isLoadingUser) {
                unsubscribe();
                return resolve(state.company);
              }
            });
          });
        }
        useIdentityStore.setState({ isLoadingCompany: true });
        const company2 = yield createFetcher("company")();
        useIdentityStore.setState({
          company: company2,
          isLoadingCompany: false,
          isCompanyFetched: true
        });
        return company2;
      } catch (error) {
        onError === null || onError === void 0 ? void 0 : onError(error);
        useIdentityStore.setState({
          isLoadingCompany: false,
          companyError: error
        });
      }
    });
    const [company, user] = yield Promise.all([
      fetchCompanyProfile(),
      fetchUserProfile()
    ]);
    if (company && user) {
      initializeAnalytics({ company, user });
    }
    return { company, user };
  } catch (error) {
    onError === null || onError === void 0 ? void 0 : onError(error);
    useIdentityStore.setState({ globalError: error });
    return {
      company: useIdentityStore.getState().company,
      user: useIdentityStore.getState().user
    };
  }
});
const handleFetchAppData = () => __awaiter(void 0, void 0, void 0, function* () {
  const [{ company, user }, client] = yield Promise.all([
    fetchProfiles(),
    fetchFeatureFlags()
  ]);
  return { client, company, user };
});
const identify = (token, { onError } = {}) => {
  useIdentityStore.setState({ onError, token });
  return handleFetchAppData();
};
const createExperimentClient = ({ experimentAPIKey, experimentServerURL }) => {
  if (!experimentAPIKey) {
    throw new Error("No experiment API key provided");
  }
  const config = {};
  if (experimentServerURL) {
    Object.assign(config, { serverUrl: experimentServerURL });
  }
  return Experiment.initialize(experimentAPIKey, config);
};
const initialize = (config) => __awaiter(void 0, void 0, void 0, function* () {
  const experimentClient = createExperimentClient(config);
  useIdentityStore.setState(Object.assign({ experimentClient, isInitialized: true }, config));
  fetchGlobalFlags();
});
const useIdentity = () => {
  const { areGlobalFeaturesFetched, companyError, userError, featuresError, globalError, isInitialized, isLoadingCompany, isLoadingFeatures, isLoadingUser, isCompanyFetched, isUserFetched, areFeaturesFetched } = useIdentityStore();
  const isLoading = [isLoadingCompany, isLoadingFeatures, isLoadingUser].some(Boolean);
  const isUserIdentified = [
    isCompanyFetched,
    isUserFetched,
    areFeaturesFetched
  ].every(Boolean);
  const error = globalError || userError || companyError || featuresError;
  return {
    areGlobalFeaturesFetched,
    error,
    isInitialized,
    isUserIdentified,
    isLoading,
    identify,
    initialize
  };
};
const useTokenSubscription = (callback) => {
  useEffect(() => {
    const unsubscribe = useIdentityStore.subscribe((state, prev) => {
      if (state.token && state.token !== prev.token) {
        callback(state.token);
      }
    });
    return unsubscribe;
  }, [callback]);
};
const getToken = () => __awaiter(void 0, void 0, void 0, function* () {
  const token = useIdentityStore.getState().token;
  if (!token || !isExpired(token)) {
    return Promise.resolve(token);
  }
  const refreshed = yield refreshToken();
  return refreshed;
});
const fetchToken = () => __awaiter(void 0, void 0, void 0, function* () {
  const application = useApplication.getState().application;
  const csrfToken = Cookies.get(CSRF_COOKIE_ID);
  const url = joinPath(application.recognizeOrigin, "api/v2/jwt");
  const res = yield fetch(url, {
    credentials: "include",
    headers: Object.assign({ "X-BONUSLY-SOURCE": "internal" }, csrfToken && {
      [CSRF_COOKIE_ID]: csrfToken
    })
  });
  const json = yield res.json();
  return json.jwt;
});
const refreshToken = () => __awaiter(void 0, void 0, void 0, function* () {
  const jwt = yield fetchToken();
  useIdentityStore.setState({ token: jwt });
  return jwt;
});
const AuthProvider = ({ children, jwt: providedJWT }) => {
  const { application } = useApplication();
  const { isInitialized, initialize: initialize2 } = useIdentity();
  const loadInitialJWT = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
    if (providedJWT) {
      identify(providedJWT);
      return;
    }
    const jwt = yield fetchToken();
    if (!jwt) {
      const loginURL = joinPath(application.recognizeOrigin, "users/sign_in_start");
      window.location.assign(loginURL);
      return;
    }
    identify(jwt);
  }), [application, providedJWT]);
  if (!isInitialized) {
    initialize2(Object.assign({ analyticsAPIKey: application.amplitudeAnalyticsApiKey, experimentAPIKey: application.amplitudeExperimentApiKey, profileBaseURL: joinPath(application.recognizeOrigin, "api/v2/profile") }, !application.isDevelopment() && {
      analyticsServerURL: joinPath(application.recognizeOrigin, "/amplitude/events/2/httpapi"),
      experimentServerURL: joinPath(application.recognizeOrigin, "/amplitude/features")
    }));
    loadInitialJWT();
  }
  return jsx(Fragment, { children });
};
export {
  AuthProvider,
  enabled,
  fetchToken,
  getToken,
  identify,
  initialize,
  refreshToken,
  track,
  useAnalytics,
  useCurrentCompany,
  useCurrentUser,
  useCurrentUserAuth,
  useFeatureFlag,
  useIdentity,
  useIdentityStore,
  useTokenSubscription
};
